// extracted by mini-css-extract-plugin
export var backupIcon = "_ni-1";
export var image = "_ni-0";